// choices/styleChoices.js
import { images } from "../../components/utility/imageImports";

const styleChoicesBg = (room) => [
  {
    label: "Индустриален",
    value: "industrial",
    imageUrl: images[`industrial/${room}/forForm.jpg`],
  },
  {
    label: "Скандинавски",
    value: "scandinavian",
    imageUrl: images[`scandinavian/${room}/forForm.jpg`],
  },
  {
    label: "Средиземноморски",
    value: "mediterranean",
    imageUrl: images[`mediterranean/${room}/forForm.jpg`],
  },
  {
    label: "Кикладски",
    value: "cycladic",
    imageUrl: images[`cycladic/${room}/forForm.jpg`],
  },
  {
    label: "Неокласически",
    value: "neoclassical",
    imageUrl: images[`neoclassical/${room}/forForm.jpg`],
  },
  {
    label: "Минималистичен",
    value: "minimal",
    imageUrl: images[`minimal/${room}/forForm.jpg`],
  },
  {
    label: "Модерен",
    value: "modern",
    imageUrl: images[`modern/${room}/forForm.jpg`],
  },
  {
    label: "Бохо",
    value: "boho",
    imageUrl: images[`boho/${room}/forForm.jpg`],
  },
  {
    label: "Винтаж/Ретро",
    value: "vintage",
    imageUrl: images[`vintage/${room}/forForm.jpg`],
  },
  {
    label: "Поп",
    value: "pop",
    imageUrl: images[`pop/${room}/forForm.jpg`],
  },
];

export default styleChoicesBg;
